import React from 'react';
import { Select, Divider, List, Col, Row, Radio, Button, Popover } from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet } from '../../actions';
import PlaylistTableView from '../views/PlaylistTableView';
import Column from 'antd/lib/table/Column';
import ActionButton from '../ActionButton';
import "./PlaylistSelectorPopup.css";
import PopupManager from '../../managers/PopupManager';
import DataHelper from '../../helpers/DataHelper';

const { Option } = Select;

// const SCALE_TYPES = ["fill", "contain", "cover", "none", "scale-down"]
const SCALE_TYPES = ["fill", "contain", "cover", "none"]
const SCALE_TYPE_DESCRIPTIONS = ["Media is sized to fill the channel's boundary", "Media is scaled to maintain its aspect ratio while fitting within the channel's boundary", "Media is sized to maintain its aspect ratio while filling the channel's boundary. The media will be clipped to fit", "Media is not resized"]
class ScaleSelectorPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = { selectedScale: "cover" }
    }

    componentDidMount() {
        const { mediaData = "cover" } = this.props;
        this.setState({ selectedScale: mediaData.Scale });
        // this.reloadPlaylists();
    }


    filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }

    onChange = (value, selectedOptions) => {
        const { onChange } = this.props;
        onChange(value, selectedOptions);
    }

    onNameChange = event => {
        this.setState({
            newPlaylistName: event.target.value,
        });
    };

    saveScale = () => {
        const { requestServerPost, usertoken, mediaData } = this.props
        const params = new FormData();

        params.append("mediaid", mediaData.MediaID)
        params.append("scale", this.state.selectedScale)

        requestServerPost("update_media", params, {  }, (response) => {
            PopupManager.closePopup();
        }, usertoken);
    }

    renderList = () => {

        const { onItemSelected = () => { } } = this.props
        return (
            <Row gutter={[16, 16]} justify="center" style={{ textAlign: "center", margin: "24px" }}>
                <Col span={24} className="page-header-title">
                    Select Media Scaling Preference
               </Col>
                <Col span={24} className="page-header-subtitle">
                    Select how each media should be scaled in reponse to different channel sizes
                </Col>
                <Col span={24} className="page-header-subtitle">
                    <img src="/cms/assets/images/scale_sample.png" style={{ display: "block !important", alt: "", fontSize: "0px", objectFit: "contain", width: "100px", height: "100px", background: "#ccc" }}></img>
                </Col>
                <Col span={24} className="page-header-subtitle">
                    (Original Media)
                </Col>
                {SCALE_TYPES.map((scale, index) => {
                    const borderColor = (scale === this.state.selectedScale) ? "#096DD9" : "#dfdfdf"
                    return <Popover content={SCALE_TYPE_DESCRIPTIONS[index]} style={{ width: "250px" }}> <Col span={24}><Row onClick={() => {
                        this.setState({ selectedScale: scale })
                    }} style={{ width: "150px", height: "120px", border: `2px solid ${borderColor}`, borderRadius: "4px", margin: "2px", cursor: "pointer" }} justify="center">
                        <Col span={24} className="center-content">
                            <img src="/cms/assets/images/scale_sample.png" style={{ display: "block !important", alt: "", fontSize: "0px", objectFit: scale, width: "120px", height: "60px", background: "#ccc" }}></img>
                        </Col>
                        <Col span={24} className="center-content">
                            <Radio checked={this.state.selectedScale === scale} onChange={(checked) => {
                                if (checked) {
                                    this.setState({ selectedScale: scale });
                                }
                            }}>{scale}</Radio>
                        </Col>
                    </Row>
                    </Col>
                    </Popover>
                })}
                <Col span={24} >
                    <Button type="primary" onClick={this.saveScale}>Save</Button>
                </Col>
            </Row>
        )
    }

    render() {
        const { requestServerPost, usertoken } = this.props;
        return (
            // <Cascader
            //     options={this.state.playlistOptions}
            //     onChange={this.onChange}
            //     placeholder="Select Playlist"
            //     showSearch={this.filter}
            // />

            <>{this.renderList()}</>

        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage, requestNodeServerPost })(ScaleSelectorPopup);